import { render, staticRenderFns } from "./StarRatingComponent.vue?vue&type=template&id=fe61402c&scoped=true&"
import script from "./StarRatingComponent.vue?vue&type=script&lang=js&"
export * from "./StarRatingComponent.vue?vue&type=script&lang=js&"
import style0 from "./StarRatingComponent.vue?vue&type=style&index=0&id=fe61402c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe61402c",
  null
  
)

export default component.exports